export const biModal = {
	modal: null,
	idOpenButton: null,
	openEvent: null,

	init(modal) {
		this.configureModal(modal);
		this.createEvents();
		this.addListeners();
		return this;
	},

	createEvents() {
		this.openEvent = new CustomEvent('modalOpen');
	},

	configureModal(modal) {
		this.modal = modal;
		this.idOpenButton = jQuery(this.modal).data('name');
	},

	openModal() {
		jQuery(this.modal).addClass('modal--open');
		jQuery('body').css('overflow', 'hidden');
		if (this.modal instanceof Element) {
			this.modal.dispatchEvent(this.openEvent);
		}
	},

	isOpen() {
		return jQuery(this.modal).hasClass('modal--open');
	},

	closeModal() {
		jQuery(this.modal).removeClass('modal--open');
		jQuery('body').css('overflow', 'auto');
	},

	addListeners() {
		const self = this;

		// listener for opening modal
		jQuery('#' + this.idOpenButton).on('click', function () {
			self.openModal();
		});

		// listner for closing modal
		jQuery(this.modal)
			.find('.modal__close')
			.on('click', function () {
				self.closeModal();
			});

		jQuery(this.modal)
			.find('.modal__background')
			.on('click', function () {
				self.closeModal();
			});
	},
};
